/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { REMOVE_GROUP_PARTICIPANT } from "./actionTypes"
import { apiError, removeGroupParticipantSuccess } from "./actions"

//Include Both Helper File with needed methods
import { deleteGroupParticipant } from "../../../helpers/backend_helper"

function* remove(action) {
  try {
    const response = yield call(deleteGroupParticipant, action.payload.form)
    if (response == undefined) throw new Error("API error")
    if (!response.success) throw new Error("Error al agregar el usuario")
    yield put(removeGroupParticipantSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* groupParticipantRemoveSaga() {
  yield takeEvery(REMOVE_GROUP_PARTICIPANT, remove)
}

export default groupParticipantRemoveSaga
